import ZoomPan from "./ZoomPan";
export default ZoomPan;
